import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

// material

import { useTheme, styled } from '@mui/material/styles';


import {
    List,
    ListItem,
    ListItemText,
    InputLabel,
    FormControl,
    Select,
    MenuItem,
    Card,
    Table,
    Stack,
    Avatar,
    Button,
    Checkbox,
    TableRow,
    TableBody,
    TableCell,
    Container,
    Typography,
    TableContainer,
    TablePagination,
    Grid,
    Box,
    Identifier,
    Iconify,
    Divider,
    RadioGroup,
    FormControlLabel,
    Radio,
    Rating,
    LinearProgress
} from '@mui/material';
// components
import Page from '../../../components/Page';
import Scrollbar from '../../../components/Scrollbar';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../../sections/@dashboard/user';
import AppsService from '../../../services/apps_service'
import { useDispatch } from 'react-redux';
import Review from '../common/Review';


// ----------------------------------------------------------------------
const useStyles = styled((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));


export const FILTER_RATING_OPTIONS = ['up5Star', 'up4Star', 'up3Star', 'up2Star', 'up1Star'];

function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    if (query) {
        return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
}

export default function ReviewsPage() {
    const params = useParams();
    const [page, setPage] = useState(0);

    const [order, setOrder] = useState('asc');

    const [selected, setSelected] = useState([]);

    const [orderBy, setOrderBy] = useState('name');

    const [filterName, setFilterName] = useState('');

    const navigate = useNavigate();

    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);

    const [app_versions, setAppVersions] = useState([]);
    const [app_countries, setAppCountries] = useState([]);

    const dispatch = useDispatch();


    const classes = useStyles();
    const [rating, setRating] = useState('');
    const [country, setCountry] = useState('');
    const [appVersion, setAppVersion] = useState('');
    const [language, setLanguage] = useState('');

    const handleChangeRating = (event, rating) => {
        setRating(event.target.value);
        setPage(0);
    };

    const handleChangeCountry = (event) => {
        setCountry(event.target.value);
        setPage(0);
    };

    const handleChangeAppVersion = (event) => {
        setAppVersion(event.target.value);
        setPage(0);
    };

    const handleChangeLanguage = (event) => {
        setLanguage(event.target.value);
        setPage(0);
    };



    dispatch({ type: 'APP', payload: { 'app': params.app_id, 'selected': 'reviews' } })

    useEffect(() => {
        return () => {
            dispatch({ type: '', payload: { 'app': params.app_id } })
        }
    }, [])

    function loadReviews() {
        AppsService.getReviews(params.app_id, page, rating, language, country, appVersion)
            .then((response) => response.data)
            .then((data) => setData(data['data']))
            .then((data) => setIsLoading(false))
            .catch((error) => {
                if (error.response.status === 404) {
                    navigate('/404')
                }
            });
    }

    function loadAppVersions() {
        AppsService.getAppVersions(params.app_id, rating, country, appVersion)
            .then((response) => response.data)
            .then((data) => setAppVersions(data['data']))
            .then((data) => setIsLoading(false))
            .catch((error) => console.log(error))
    }

    function loadAppCountries() {
        AppsService.getAppCountries(params.app_id, rating, country, appVersion)
            .then((response) => response.data)
            .then((data) => setAppCountries(data['data']))
            .then((data) => setIsLoading(false))
            .catch((error) => console.log(error))
    }

    useEffect(() => {
        loadReviews();
    }, [page, rating, language, country, appVersion]);

    useEffect(() => {
        // if (isLoading) {
        loadAppVersions();
        loadAppCountries();
        // }
    }, [rating, country, appVersion]);



    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        loadReviews();
    };



    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        // setSelected(newSelected);
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        // loadReviews();
    };



    return (
        <Page title="Reviews">
            <Container maxWidth="xl">
                <Grid container spacing={3}>

                    <Grid item xs={20} sm={10} md={9}>
                        {data.length === 0 && isLoading && (
                            <LinearProgress />
                        )}
                        <Scrollbar>
                            <Stack spacing={3} sx={{ p: 3, pr: 0 }}>
                                {data.map((review) => (
                                    <Review id={review.id} key={review.id} title={review.review_title} content={review.review_content} rating={review.rating} author={review.author_name} date={review.review_date} country={review.review_country} app_version={review.app_version} />
                                    // <ReviewItem key={review.id} review={review} />
                                ))}
                            </Stack>
                        </Scrollbar>

                        <TablePagination
                            rowsPerPageOptions={[10]}
                            component="div"
                            count={-1}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            nextIconButtonProps={(data.length < rowsPerPage) ? { "disabled": true } : {}}
                            onPageChange={handleChangePage}
                        />

                    </Grid>
                    <Grid item xs={20} sm={10} md={3}>
                        <Stack spacing={3} sx={{ p: 3, pr: 0 }}>
                            <FormControl className={classes.formControl}>
                                <InputLabel id="rating-label">Rating</InputLabel>
                                <Select
                                    labelId="rating-label"
                                    id="rating-select"
                                    value={rating}
                                    onChange={handleChangeRating}
                                >
                                    <MenuItem value="">
                                        <em>All</em>
                                    </MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                    <MenuItem value={4}>4</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl}>
                                <InputLabel id="country-label">Country</InputLabel>
                                <Select
                                    labelId="country-label"
                                    id="country-select"
                                    value={country}
                                    onChange={handleChangeCountry}
                                >
                                    <MenuItem value="">
                                        <em>All</em>
                                    </MenuItem>
                                    {app_countries.map((country) => (
                                        <MenuItem value={country}>{country}</MenuItem>
                                    ))}

                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl}>
                                <InputLabel id="app-version-label">App Version</InputLabel>
                                <Select
                                    labelId="app-version-label"
                                    id="app-version-select"
                                    value={appVersion}
                                    onChange={handleChangeAppVersion}
                                >

                                    <MenuItem value="">
                                        <em>All</em>
                                    </MenuItem>
                                    {app_versions.map((version) => (
                                        <MenuItem value={version}>{version}</MenuItem>
                                    ))}
                                    {/* <MenuItem value="1.0">1.0</MenuItem> */}
                                    {/* <MenuItem value="1.1">1.1</MenuItem> */}
                                    {/* <MenuItem value="2.0">2.0</MenuItem> */}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControl}>
                                <InputLabel id="language-label">Language</InputLabel>
                                <Select
                                    labelId="language-label"
                                    id="language-select"
                                    value={language}
                                    onChange={handleChangeLanguage}
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value="English">English</MenuItem>
                                    <MenuItem value="French">French</MenuItem>
                                    <MenuItem value="Spanish">Spanish</MenuItem>
                                    <MenuItem value="German">German</MenuItem>
                                    <MenuItem value="Other">Other</MenuItem>
                                </Select>
                            </FormControl>
                        </Stack>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}
